<template>
<div class="Kanit BGwhite">
  <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; overflow-y: color: rgb(74, 74, 74) !important;">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; margin-top: -4vh;">
          <v-container grid-list-md class="mt-2">
            <v-layout wrap>
              <v-flex sm12 md12 lg12 xl12>
               <v-btn icon flat @click="backlink()"><v-icon>navigate_before</v-icon></v-btn>
                <h2 >สร้างบอท</h2>
              </v-flex>

              <v-flex>
                <v-stepper v-model="e2" vertical class="stepper-css">
                  <v-stepper-step step="1" :color="e2 ===1 ? '#912f56':'green'" :complete="e2 > 1">
                    <div class="v-stepper__label" :style="e2 ===1 ? 'color:#912f56': 'color:green'">
                      ขั้นตอนที่ 1
                    </div>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-flex class="text-card">
                      <p class="SettingTtl">ID บอท : <span style="color: red; font-weight: 400;"> *</span></p>
                      <div>
                        <div class="EditArea">
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <v-text-field @keypress="isNumandaz($event)" type="text" hide-details single-line v-model="botid" solo flat label="ไอดีสำหรับการค้นหา เพิ่มเพื่อน">
                              </v-text-field>
                            </div>
                            <div v-if="progressCheckId" style="justify-content: start; display: flex; margin-left: 10px;margin-top: 10px;">
                              <v-progress-circular :size="15" :width="3" :indeterminate="progressCheckId" color="gray"></v-progress-circular>
                            </div>
                            <div v-else>
                              <p class="EditAreaNote" style="color:red;">{{botiderror}}</p>
                              <p class="EditAreaNote" style="color:green;" v-if="botid != '' && botidstatus"><i class="fas fa-check" style="color:green;"></i> ID บอทนี้สามารถใช้ได้</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="SettingTtl" style="margin-top:2vh;">ชื่อบอท : <span style="color: red; font-weight: 400;"> *</span></p>
                      <div>
                        <div class="EditArea">
                          <div class="EditAreaCont">
                            <div class="EditAreaContFlex">
                              <v-text-field solo flat type="text" label="ชื่อที่บุคคลทั่วไปเห็น" hide-details single-lin v-model="botname"></v-text-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-layout row wrap style="margin-top:10px;">
                        <v-btn flat class="buttonclear" @click="clearinfo_bot()">ล้างข้อมูล</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="buttoncreate" @click.native="e2=2" :disabled="botid == '' || botname == '' || botiderror !== ''">ถัดไป</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-stepper-content>

                  <v-stepper-step step="2" :color="e2===2 ? '#912f56':'green'">
                    <div class="v-stepper__label" :style="e2 ===2 ? 'color:#912f56': 'color:grey'">
                      ขั้นตอนที่ 2
                    </div>
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <v-flex class="text-card">
                      <v-form ref="form" class="Kanit labeltext" v-model="valid">
                        <p class="SettingTtl" style="margin-top:2vh;">รหัสผ่าน :</p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont">
                              <div class="EditAreaContFlex">
                                <v-text-field type="password" v-model="botpassword" :rules="botpasswordRules" label="รหัสผ่านที่ใช้ในการเพิ่มบอทเป็นเพื่อน" counter solo flat hide-details single-line required maxlength="6"></v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="SettingTtl" style="margin-top:2vh;">ยืนยันรหัสผ่าน :</p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont">
                              <div class="EditAreaContFlex">
                                <v-text-field type="password" v-model="rePassword" :rules="repasswordRules" label="ยืนยันรหัสผ่าน" counter solo flat hide-details single-line required maxlength="6"></v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="SettingTtl" style="margin-top:2vh;">Webhook : <span style="font-weight: normal;">(ถ้ามี)</span></p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont">
                              <div class="EditAreaContFlex">
                                <v-text-field type="text" label="เว็บไซต์ของผู้พัฒนา เพื่อจัดการข้อความที่ได้รับ" solo flat hide-details single-line v-model="webhook"></v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="SettingTtl" style="margin-top:2vh;">ข้อความตอบกลับ หลังเพิ่มเพื่อน : <span style="font-weight: normal;">(ถ้ามี)</span></p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont">
                              <div class="EditAreaContFlex">
                                <v-text-field type="text" label="ข้อความตอบกลับอัตโนมัติ หลังการเพิ่มเพื่อน" solo flat hide-details single-line v-model="msg_reply"></v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="SettingTtl" style="margin-top:2vh;">เหตุผล : <span style="font-weight: normal;">(ถ้ามี)</span></p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont">
                              <div class="EditAreaContFlex">
                                <v-text-field type="text" label="รายละเอียดหรือเหตุผล สำหรับการสร้างบอท" solo flat hide-details single-line v-model="detail"></v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-form>

                      <v-layout row wrap style="margin-top:10px;">
                        <v-btn class="buttoncreate" @click.native="e2 = 1">ย้อนกลับ</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="buttonclear" @click="clearinfo()">
                          <span>ล้างข้อมูล</span>
                        </v-btn>
                        <v-btn :loading="loading" :disabled="botidstatus == '' || botname == ''" class="buttoncreate" @click="submit()">
                          <span>สร้างบอท</span>
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-stepper-content>
                </v-stepper>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-text>
</div>
</template>
<script>
import {
  mapState
} from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
// import $ from 'jquery'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  data() {
    return {
      progressCheckId: false,
      e2: 1,
      e1: 0,
      loader: null,
      loading: false,
      development: '',
      token: '',
      name: '',
      status: '',
      filename: '',
      webbackend: '',
      botid: '',
      botiderror: '',
      botidstatus: false,
      botname: '',
      detail: '',
      webhook: '',
      msg_reply: '',
      botpassword: '',
      rePassword: '',
      windowWidth: '',
      botpasswordRules: [
        v => !!v || '',
        // v => v.length >= 6 || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว',
        v => (!!v && v.length >= 6) || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว',
        v => /^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น',
        v => /[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้'
        // v => (v === this.rePassword && this.rePassword !== '') || 'กรุณาใส่รหัสผ่านให้ตรงกัน'
      ],
      repasswordRules: [
        v => !!v || '',
        v => /^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น',
        v => /[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้',
        v => (!!v && v.length >= 6) || 'กรุณากรอกรหัสผ่านซ้ำ',
        v => v === this.botpassword || 'กรุณากรอกรหัสผ่านให้ตรงกัน'
      ],
      valid: false
    }
  },
  methods: {
    isNumandaz($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) { // 46 is dot
        $event.preventDefault()
      }
    },
    updatename() {
      this.editname = !this.editname
      this.$http.post(process.env.APImanage + '/setnameuser', {
        tokenuser: this.token,
        name: this.nameedit
      }).then((response) => {
        // console.log(this.token)
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
    },
    updatestatus() {
      this.editdescription = !this.editdescription
      this.$http.post(process.env.APImanage + '/setstatususer', {
        tokenuser: this.token,
        status: this.statusedit
      }).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    clearinfo() {
      this.detail = ''
      this.webhook = ''
      this.msg_reply = ''
      this.botpassword = ''
      this.rePassword = ''
      this.$refs.form.reset()
    },
    clearinfo_bot() {
      this.botid = ''
      this.botname = ''
      this.botiderror = ''
      this.botidstatus = false
    },
    checkID() {
      if (this.botid !== '') {
        this.progressCheckId = true
        this.$http.post(process.env.APImanage + '/checkbotid', {
          bot_id: this.botid
        }).then((response) => {
          if (response.body['status'] === 'success') {
            this.botiderror = ''
            this.botidstatus = true
            this.progressCheckId = false
          } else if (response.body['status'] === 'fail' && response.body['message'] === 'id duplicate') {
            this.progressCheckId = false
            this.botiderror = 'ไอดีนี้ถูกใช้ไปแล้ว'
            this.botidstatus = false
          }
        }).catch(error => {
          console.log(error)
          this.progressCheckId = false
        })
      }
    },
    submit() {
      if (this.botpassword !== '' && this.rePassword === '') {
        this.$swal('', 'กรุณายืนยันรหัสผ่าน', 'warning')
      } else if (this.botpassword === '' && this.rePassword !== '') {
        this.$swal('', 'กรุณากรอกรหัสผ่าน', 'warning')
      } else {
        this.loader = 'loading'
        this.$http.post(process.env.APImanage + '/createbot2', {
          token_owner: this.token,
          bot_id: this.botid,
          bot_name: this.botname,
          detail: this.detail,
          webhook: this.webhook,
          message_default: this.msg_reply,
          password: this.botpassword
        }).then((response) => {
          // console.log(response.body)
          if (response.body['status'] === 'success') {
            this.route_botid({
              'message_default': this.msg_reply,
              'webhook': this.webhook,
              'nickname': this.botname,
              'profilepicture': '',
              'tokenuser': response.body.tokenBot,
              'type': 'bot',
              'bot_id': this.botid,
              'password': this.botpassword
            })
            this.$store.dispatch('listFriend', 'addbot' + response.body['tokenBot'])
            this.$swal(
              'Success!',
              'สร้างบอทสำเร็จ',
              'success'
            )
            this.loader = null
            this.clearinfo()
          } else {
            this.$swal(
              'สร้างบอทไม่สำเร็จ',
              'เนื่องจากเซิร์ฟเวอร์มีปัญหา กรุณาติดต่อผู้ดูแลระบบ.',
              'error'
            )
            this.loader = null
          }
        }, (response) => {
          console.log(response)
          this.loader = null
          this.$swal(
            'สร้างบอทไม่สำเร็จ',
            'เนื่องจากเซิร์ฟเวอร์มีปัญหา กรุณาติดต่อผู้ดูแลระบบ.',
            'error'
          )
        })
      }
    },
    route_botid(data) {
      this.$store.dispatch('tokenRoom', data.bot_id)
      this.$store.dispatch('changeBot', data)
      localStorage.setItem('room', data.bot_id)
      this.$store.dispatch('changeRightTool', 'Friend')
      this.$cookies.set('tokenRoom', data.bot_id)
      this.$router.push('/develop/homepage/' + data.bot_id + '/' + data.tokenuser)
    },
    backlink() {
      this.$router.go(-1)
      // this.$router.push('/develop/homepage/' + this.botid)
    },
    next() {
      this.e2 = this.e2 + 1
      console.log(this.e2)
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile'
    })
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth() {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/dev_createbot')
      }
    },
    myprofile() {
      // console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    },
    botid() {
      if (this.botid === '') {
        this.botidstatus = false
      } else {
        this.checkID()
      }
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    }
  },
  created() {
    // this.phone = localStorage.getItem('phone')
    // this.email = localStorage.getItem('email')
    this.token = localStorage.getItem('tokenuser')
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.webbackend = process.env.API
    this.filename = localStorage.getItem('profilepicture')
    this.development = '-'
    this.tokenservice = localStorage.getItem('tokenservice')
    this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('email'))
    this.nameedit = this.name
    this.statusedit = this.status
  }
}
</script>
<style type="text/css" scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-card {
  border-radius: 2px;
  box-shadow: none;
  display: block;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25, .8, .5, 1);
}

.v-messages__message {
  -ms-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  line-height: 2;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
}

/* .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
  border-style: solid;
  border-width: thin;
  border-radius: 5px;
  border-color: #d2d8dd;
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 42px !important;
  padding: 0 !important;
} */

.buttonclear {
  border: none !important;
  border-radius: 5px !important;
  /* background-color: #bdbdbd !important;
  border-color: #bdbdbd !important; */
  background-color: #4A5859 !important;
  color: white !important;
  width: 105px !important;
  box-shadow: none !important;
}

.buttoncreate {
  border: none !important;
  border-radius: 5px !important;
  background-color: #2562af !important;
  /* border-color: #bdbdbd !important; */
  width: 105px !important;
  color: white !important;
  box-shadow: none !important;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.edit {
  font-weight: 100;
}

.inputWrapper {
  height: 32px;
  width: 90px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*margin-top: 5vh;*/
  /*Using a background color, but you can use a background image to represent a button*/
  /*background-color: #DDF;*/
}

.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}

.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}

input[type=textprofile] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=textprofile]:disabled {
  background: #cac9c9;
}

.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}

.urlcopymessageapi {
  display: none !important;
}

.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}

.header {
  display: block;
  font-size: 1.17em;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: black !important;
}

.header::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #1a76d2;
}

.Setting {
  margin-bottom: 2vh;
}

.SettingBlock {
  padding: 20px 20px;
  border-top: 1px solid #DEE5EC;
}

.SettingBlock> :last-child {
  margin-bottom: 0;
}

.List_Register {
  margin-bottom: 32px;
  box-sizing: border-box;
}

.List_Register .List_item:last-child {
  border-bottom: none;
}

.List_Register .List_item {
  display: -webkit-flex;
  display: flex;
  padding: 0;
}

.List_Register .List_item:last-child .List_item_header {
  width: 200px;
}

.SettingTtl {
  margin-bottom: 8px;
  font-weight: bold;
  white-space: nowrap;
  color: black !important;
}

.md91SettingImg {
  padding-bottom: 12px;
  line-height: 1;
}

.SettingImgWrap {
  display: inline-block;
  position: relative;
  border-radius: 40px;
  overflow: hidden;
}

.SettingImgMask {
  position: relative;
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 40px;
}

.SettingImgBtn {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 30px;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 50%;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .75);
}

.SettingImgInput {
  position: absolute;
  left: -9999px;
}

.EditAreaNote {
  margin: 8px 0 0;
  font-size: 13px;
  color: #BEC8D2;
  font-size: 12px;
}

.EditArea {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}

.BreakWord {
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
  word-wrap: break-word;
}

.EditAreaCont {
  width: 100%;
  padding-right: 1em;
  box-sizing: border-box;
}

.SettingQr {
  display: -webkit-flex;
  display: flex;
}

.SettingQrImg {
  margin: 0 50px;
  position: relative;
}

.SettingQrNote {
  margin-bottom: 0;
  font-size: 13px;
}

.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
  margin-left: 0;
}

.EditAreaContFlex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}

.InputEdit {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d2d8dd;
  border-radius: 4px;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}

/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/

.mb-5 {
  /* background-color: rgba(187, 184, 184, 0.2); */
  padding: 10px 10px 4px;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #4A5859;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  color: green;
}

.stepper-css {
  /*background-color: rgba(190, 187, 187, 0.055);*/
}

/* .v-text-field.v-text-field--outline .v-input__control .v-inout__slot {
  max-height: 48px;
}
.v-text-field>>>.v-input__control>>>.v-input__slot {
    cursor: text;
    height: 48px;
} */

/* .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none;
    border: solid;
} */

>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 10px;
  background: rgb(255, 252, 252);
  border: solid 2px rgba(0, 0, 0, .4);
}

.v-stepper--vertical .v-stepper__content {
  margin: -8px -36px -16px 36px;
  padding: 16px 60px 16px 23px;
  width: auto;
}

.v-stepper--vertical .v-stepper__step {
  padding: 24px 24px 16px;
  padding-top: 12px;
  padding-right: 24px;
  padding-bottom: 12px;
  padding-left: 24px;
}

>>>.v-stepper,
.v-stepper__header {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/managebot/createbot.vue